import { InjectedFormikProps, withFormik } from 'formik';
import * as React from 'react';
import { NotificationManager } from 'react-notifications';
import { Subtract } from 'utility-types';
import * as Yup from 'yup';

export interface IBecomePartnerFormValues {
  email: string;
  firstname: string;
  lastname: string;
  country: string;
  city: string;
}

interface IFormProps {
  onSubmit: (values: IBecomePartnerFormValues) => Promise<void>;
}

export type WithBecomePartnerFormProps = InjectedFormikProps<
  IFormProps,
  IBecomePartnerFormValues
> & {
  email?: string;
  firstname?: string;
  lastname?: string;
  country?: string;
  city?: string;
};

export const withBecomePartnerFormState = <
  P extends WithBecomePartnerFormProps
>(
  Component: React.ComponentType<P>
) =>
  withFormik<
    IFormProps & Subtract<P, WithBecomePartnerFormProps>,
    IBecomePartnerFormValues
  >({
    handleSubmit: async (
      values,
      { props, setSubmitting, setError, resetForm }
    ) => {
      setSubmitting(true);
      try {
        await props.onSubmit(values);
        NotificationManager.success('Successfully submitted response');
        resetForm({
          email: '',
          firstname: '',
          lastname: '',
          message: ''
        });
      } catch (e) {
        NotificationManager.warning('Failed to submit response');
      }
      setSubmitting(false);
    },
    mapPropsToValues: () => ({
      city: '',
      country: '',
      email: '',
      firstname: '',
      lastname: ''
    }),
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: Yup.object().shape({
      city: Yup.string().required(),
      country: Yup.string().required(),
      email: Yup.string()
        .email()
        .required(),
      firstname: Yup.string().required(),
      lastname: Yup.string().required()
    })
  })(Component);

export default withBecomePartnerFormState;



// WEBPACK FOOTER //
// ./src/components/BecomePartnerForm/withBecomePartnerFormState.tsx